import { createSelector } from "reselect"
import { find } from "lodash"
import { getViewType, getPortfolioName } from "modules/portfolio-root/selectors/portfolios"
import { getContentSets } from "selectors/contentSets"
import { getDisplayTypeName, getContentSetId } from "./items"
import { computeFileName } from "helpers/analyze"

const getStartDate = (_, props) => props.startDate
const getEndDate = (_, props) => props.endDate

export const getScreenName = createSelector(
  [getContentSets, getContentSetId],
  (contentSets, contentSetId) => {
    if (contentSetId) {
      const contentSet = find(contentSets, ({ id }) => id === contentSetId)
      if (contentSet) {
        return `${contentSet.name} Exposure`
      }
    }
    return "Exposure"
  },
)

export const getFileName = createSelector(
  [getPortfolioName, getDisplayTypeName, getViewType, getScreenName, getStartDate, getEndDate],
  computeFileName,
)
